import React from 'react'
import { EntryPage } from '@emerald-works-nova/auth'
import { Grid, Link } from '@mui/material'

const ResetPasswordEndPage = () => {
  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }} />
      <Grid item>
        <EntryPage
          title='👌'
          showMtLogo
          subtitle={<><b>Password set!</b><br /><br />You can get back to sign in.</>}
          content={<Link href='/login' color='inherit' underline='hover'>Back to Sign In</Link>}
          application={process.env.REACT_APP_APPLICATION_NAME}
        />
      </Grid>
    </Grid>
  )
}

export default ResetPasswordEndPage
